import { HttpClient } from '@opallabs/api'
import removeJsonApiEntities from '../removeJsonApiEntities'

const deleteMoment = (id) => HttpClient().delete(`/moments/v2/${id}`)

const destroyMoment = (id) => (dispatch) => {
  deleteMoment(id)
    .then((response) => {
      if (response.status === 202) {
        // commenting this out for now as this method doesnt exist.
        // however, we'll need to do something like this in order
        // to clean up content after their moment was deleted.
        // const state = getState();
        // const content = getNestedRelationship(state, 'jsonApiEntities', 'moment', 'relationships', 'content');
        dispatch(removeJsonApiEntities({ type: 'moment', id }))
        // if (content) dispatch(removeJsonApiEntities(content));
      }
      return null
    })
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default destroyMoment
